// @flow
import * as React from 'react';
import styled from 'styled-components';
import { CloseButton as CloseButtonBase } from 'components/Button';
import { colors } from '../theme';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 9999;
  opacity: 0.85;
  background-color: ${colors.greyishBrown};
`;

const Content = styled.div`
  position: fixed;
  display: flex;
  align-items: flex-start;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  overflow: auto;
  text-align: center;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
  cursor: pointer;

  &:after {
    vertical-align: middle;
    display: inline-block;
    height: 100%;
    margin-left: -0.05em;
    content: '';
  }
`;

export const Dialog = styled.div`
  position: relative;
  outline: 0;
  width: 100%;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.4);
  display: block;
  text-align: left;
  box-sizing: border-box;
  max-width: 520px;
  margin: auto;
  cursor: default;
  color: ${colors.greyishBrown};
  line-height: 1.5;
`;

export const CloseButton = styled(CloseButtonBase)`
  position: absolute;
  top: 10px;
  right: 4px;
  z-index: 10;
`;

type Props = {
  onClose?: Function,
  renderDialog: (onDialogClick: (Event) => void) => React.Node
};

export default class ModalBase extends React.PureComponent<Props> {
  listenKeyboard = (event: KeyboardEvent) => {
    if (
      (event.key === 'Escape' || event.keyCode === 27) &&
      this.props.onClose
    ) {
      this.props.onClose();
    }
  };

  componentDidMount() {
    if (this.props.onClose) {
      window.addEventListener('keydown', this.listenKeyboard, true);
    }
  }

  componentWillUnmount() {
    if (this.props.onClose) {
      window.removeEventListener('keydown', this.listenKeyboard, true);
    }
  }

  onOverlayClick = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  onDialogClick = (event: Event) => {
    event.stopPropagation();
  };

  render() {
    return (
      <>
        <Overlay />
        <Content
          onClick={this.onOverlayClick}
          aria-modal="true"
          id="idealist-modal-container"
        >
          {this.props.renderDialog(this.onDialogClick)}
        </Content>
      </>
    );
  }
}
